import { render, staticRenderFns } from "./CompetitionByYear.vue?vue&type=template&id=1f531168"
import script from "./CompetitionByYear.vue?vue&type=script&lang=js"
export * from "./CompetitionByYear.vue?vue&type=script&lang=js"
import style0 from "./CompetitionByYear.vue?vue&type=style&index=0&id=1f531168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports